var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('helio-button-group',{attrs:{"segmented":false,"alignment":"right"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }